<template>
  <el-col :span="span" class="search_form_container">
    <p class="search_form_label">{{ label }}:</p>
    <template v-if="type == 'text'">
      <el-input
        v-model="inputValue"
        class="search_input"
        :clearable="clearable"
        :placeholder="placeholder"
        @keyup.enter.native="keyEnter"
      ></el-input>
    </template>
    <template v-if="type == 'select'">
      <el-select
        v-model="inputValue"
        class="search_input"
        :clearable="clearable"
        :placeholder="placeholder"
        @change="inputChange"
        :single="false"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </template>
    <template v-if="type == 'datetimerange'">
      <el-date-picker
        v-model="inputValue"
        type="datetimerange"
        align="right"
        size="small"
        :start-placeholder="startPlaceholder"
        :end-placeholder="endPlaceholder"
        :default-time="defaultTime"
        :value-format="valueFormat"
        class="search_input"
        @change="inputChange"
      >
      </el-date-picker>
    </template>
    <template v-if="type == 'orgSelector'">
      <eip-org-selector
        :placeholder="placeholder"
        class="search_input"
        v-model="selectOrg"
        :single="true"
        :config="{ id: 'selectOrgId' }"
      >
      </eip-org-selector>
    </template>
  </el-col>
</template>

<script>
const eipOrgSelector = () =>
  import("@/components/eipControl/selector/EipOrgSelector.vue");
export default {
  props: {
    span: {
      type: Number,
      default: 6,
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
    },
    value: {},
    placeholder: {
      type: String,
    },
    options: {
      type: Array,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    startPlaceholder: {
      type: String,
      default: "开始时间",
    },
    endPlaceholder: {
      type: String,
      default: "结束时间",
    },
    defaultTime: {
      type: Array,
      default: () => {
        return ["00:00:00", "23:59:59"];
      },
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss",
    },
  },
  data() {
    return {
      selectOrgId: "",
      watchMap: {},
      selectOrg:""
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.type != "orgSelector") {
          this.$emit("input", val);
        }
      },
    },
  },
  components: {
    eipOrgSelector,
  },
  methods: {
    reset(){
      this.selectOrg = null;
    },
    inputChange(){
      this.$emit("search");
    },
    keyEnter: function(e){
      let keyCode = window.event ? e.keyCode : e.which;
      if(keyCode == 13){
        this.inputChange();
      }
    }
  },
  watch: {
    selectOrgId(newValue) {
      this.$emit("input", newValue);
      this.$emit("search")
    },
  },
};
</script>

<style lang="scss" scoped>
.search_input {
  width: 80%;
}
.search_form_label {
  display: block;
  margin-top: 5px;
  float: left;
  width: 15%;
}
</style>